import React from 'react'
import './index.css'
import 'rc-switch/assets/index.css'
import { BotIcon } from '../../conf/images'
import { BotModel } from '../../model/bot.model'
// import Switch from '../Switch'

export enum BotStatus {
    'NoInstalled' = 0, // 应用商店，未安装
    'Creating' = 1, // 应用商店，安装中
    'Using' = 2, // 我的Bot，服务中
    'Disable' = 3, // 我的Bot，已停用
}

interface BotItemProps {
    item?: BotModel
    type: 'botStore' | 'myBot'
    onBotAdd?: () => void
    onBotSwitch?: (checked: boolean) => void
    onBotConfig?: () => void
    onBotUpdate?: () => void
    onClick?: () => void
}
const BotItem: React.FC<BotItemProps> = (props) => {
    const {
        item,
        type = 'botStore',
        onClick,
        onBotAdd = () => undefined,
        onBotConfig = () => undefined,
        onBotUpdate = () => undefined,
    } = props
    if (!item) return null
    return (
        <div className='bot-item' onClick={onClick}>
            <img
                className='bot-item-icon'
                src={item.logo_url || BotIcon}
                alt='icon'
            />
            <div className='bot-item-content'>
                <div className='bot-item-title'>
                    <p>{item.name}</p>
                    {item.status === 0 && type === 'botStore' && (
                        <p
                            className='bot-item-toadd option-button'
                            onClick={(e) => {
                                e.stopPropagation()
                                onBotAdd()
                            }}
                        >
                            添加
                        </p>
                    )}
                    {item.status === 1 && (
                        <p className='bot-item-creating option-button'>
                            添加中
                        </p>
                    )}
                    {(item.status === 2 || item.status === 3) &&
                        type === 'botStore' && (
                            <p className='bot-item-added option-button'>
                                已添加
                            </p>
                        )}
                    {(item.status === 2 || item.status === 3) &&
                        (item.bot_type === 1 ||
                            item.name === '新闻头条' ||
                            item.name === '消息推送机器人' ||
                            item.name === '日程提醒') &&
                        type === 'myBot' && (
                            <p
                                className='bot-config-button option-button'
                                onClick={(e) => {
                                    e.stopPropagation()
                                    onBotConfig()
                                }}
                            >
                                配置
                            </p>
                        )}
                    {item.status === 4 && type === 'myBot' && (
                        <p className='bot-item-deletting option-button'>
                            移除中
                        </p>
                    )}
                </div>
                <p className='bot-item-intro'>{item.slogan}</p>
                <div className='bot-item-developer'>
                    <p className='bot-item__author'>开发者：{item.author}</p>
                    {item.has_new_version &&
                        type === 'myBot' &&
                        item.status !== 1 &&
                        item.status !== 4 && (
                            <p
                                className='bot-update-button option-button'
                                onClick={(e) => {
                                    e.stopPropagation()
                                    onBotUpdate()
                                }}
                            >
                                {item.status === 5 ? '更新中' : '更新'}
                            </p>
                        )}
                </div>
            </div>
        </div>
    )
}

export default BotItem
